<template>
  <div
    v-if="isActive"
    class="fixed z-50 -mt-[200px] flex h-[120%] w-full items-center justify-center bg-white"
  >
    <Loader />
  </div>
</template>

<script setup>
import { Loader } from 'refresh-ui'

defineProps({
  isActive: Boolean,
})
</script>
